import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      "fill-rule": "evenodd",
      d: "M14.472 3.528c.26.26.26.683 0 .943l-8 8a.667.667 0 0 1-.943 0l-4-4a.667.667 0 1 1 .943-.943L6 11.057l7.529-7.529c.26-.26.682-.26.943 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }